import { render } from "./YNWindow.vue?vue&type=template&id=b67426ae"
import script from "./YNWindow.vue?vue&type=script&lang=js"
export * from "./YNWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__